import { BrowserRouter } from "react-router-dom";
import "./App.css";
import DashboardRoutes from "./Components/DashboardRoutes";
import { useEffect, useRef } from "react";
import Constants from "./Constants";
import { authFetch } from "./utils/authFetch";

const AUTH_ENDPOINT = Constants.AUTH_BASE_URL + "/api/v1";

function App() {
  const lastChecked = useRef(0);

  useEffect(() => {
    const checkSession = () => {
      const pathName = window.location.pathname;
      if (pathName === "/") return;

      const now = Date.now();
      // Only check session every 60 seconds to avoid hammering the backend
      if (now - lastChecked.current < 60000) return;
      lastChecked.current = now;

      authFetch(`${AUTH_ENDPOINT}/session`)
        .then((res) => res.json())
        .then((res) => {
          if (!res.authenticated || !(res.user?.super_admin || res.user?.is_vendor)) {
            localStorage.clear();
            window.location.pathname = "/";
          }
        })
        .catch(() => {
          // Network error - don't kick user out immediately
        });
    };

    const events = ["load", "mousemove", "mousedown", "click", "scroll", "keydown"];
    const handlers = events.map((event) => {
      const handler = () => checkSession();
      window.addEventListener(event, handler);
      return { event, handler };
    });

    return () => {
      handlers.forEach(({ event, handler }) => {
        window.removeEventListener(event, handler);
      });
    };
  }, []);

  return (
    <BrowserRouter>
      <DashboardRoutes />
    </BrowserRouter>
  );
}

export default App;
